const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

const content = {

  async getBlogPosts() {
    const response = await fetch(`${API_URL}/api/v1/content/blog/`);
    if (!response.ok) throw new Error('Failed to fetch blog posts');
    return response.json();
  },

  async getBlogPost(slug) {
    const response = await fetch(`${API_URL}/api/v1/content/blog/${slug}/`);
    if (!response.ok) throw new Error('Failed to fetch blog post');
    return response.json();
  },

  async getCaseStudies(featured = null) {
    let url = `${API_URL}/api/v1/content/case-studies/`;
    if (featured !== null) {
      url += `?featured=${featured}`;
    }
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch case studies');
    return response.json();
  },

  async getCaseStudy(slug) {
    const response = await fetch(`${API_URL}/api/v1/content/case-studies/${slug}/`);
    if (!response.ok) throw new Error('Failed to fetch case study');
    return response.json();
  },

};

export default content;
